import { ReactNode } from "react";
import { msalConfig } from "../../utils/umgAuthConfig";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication(msalConfig);

export const MSALProvider = ({ children }: { children: ReactNode }) => (
  <MsalProvider instance={msalInstance}>{children}</MsalProvider>
);
